import { LanguageDropdown as LocalizationLanguageDropdown } from '@faceup/localization'
import { type ForwardedRef, forwardRef } from 'react'
import {
  type UseManageLanguageDropdownProps,
  useManageLanguageDropdown,
} from '../../hooks/useManageLanguageDropdown'

type LanguageDropdownProps = UseManageLanguageDropdownProps

export const LanguageDropdown = forwardRef(
  (
    { availableLanguages, defaultLanguage }: LanguageDropdownProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    const { alphabeticallySortedLanguages, defaultSelectedLanguage, changeLanguage } =
      useManageLanguageDropdown({ availableLanguages, defaultLanguage })

    return (
      <LocalizationLanguageDropdown
        ref={ref}
        activeLanguage={defaultSelectedLanguage}
        languages={alphabeticallySortedLanguages}
        onChangeLanguage={changeLanguage}
        areLanguagesNative
        className='h-11 rounded-xl border border-colorBorder border-solid bg-white px-3'
        styles={{
          targetText: {
            strong: true,
          },
        }}
      />
    )
  }
)
